import { z } from 'zod';

import { AuditLogType } from '../auditLog/AuditLogType';

export const AuditLogApi = z.object({
  id: z.string(),
  loanId: z.string(),
  losId: z.string(),
  auditLog: z.array(
    z.object({
      id: z.string(),
      type: AuditLogType,
      comment: z.string(),
      createdAt: z.iso.datetime(),
    }),
  ),
});
export type AuditLogApi = z.infer<typeof AuditLogApi>;
